import { useRef, useState } from 'react'
import MenuOptions from '../MenuOptions'
import * as Styled from './styled'
import { Props } from './types'
import { useOnClickOutside } from '~hooks'

function Navbar({ username, onClickLogout }: Props) {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const menuRef = useRef<HTMLDivElement>(null)

  const handleMenuClick = () => {
    setIsMenuOpen(!isMenuOpen)
  }

  const handleClickOutside = () => {
    setIsMenuOpen(false)
  }

  useOnClickOutside(menuRef, handleClickOutside)

  return (
    <div ref={menuRef}>
      <Styled.MenuTitle data-testid="menu" weight="bold" size="body-lg" onClick={handleMenuClick}>
        Olá, {username}
        <Styled.ArrowDropdown />
        <MenuOptions onClickLogout={onClickLogout} isOpen={isMenuOpen} onClose={() => setIsMenuOpen(false)} />
      </Styled.MenuTitle>
    </div>
  )
}

export default Navbar
